module.exports = __webpack_public_path__ + "static/media/right-circle-arrow.6ed30e64.png";